import React from 'react';
import { TrophyIcon, HourglassIcon, GlobeIcon } from 'lucide-react';
import { CtaBlock } from '../CtaBlock';
const SPOTS_LEFT = 7;
const SPOTS_TOTAL = 100;
export function Offer() {
  const filled = Math.round((SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100);
  return <section id="offre" className="w-full bg-ink-950 px-4 py-14 sm:py-20" data-id="element-219" data-mp="356celppngkvl">
      <div className="mx-auto max-w-2xl" data-id="element-220" data-mp="357nj5rqx5wnr">
        <p className="flex items-center justify-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-spark-500" data-id="element-221" data-mp="3a5ys809e434x">
          <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="3f38onzv75f29" />
          Offre spéciale de lancement
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-223" data-mp="3jvrzwq6evy3w">
          Tout ce que vous recevez aujourd’hui
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border border-spark-500/30 bg-ink-800" data-id="element-224" data-mp="3sx9fm7fwpxs2">
          <div className="divide-y divide-white/10 p-5 sm:p-6" data-id="element-225" data-mp="1qf2hb7xh2um">
            <div className="flex items-baseline justify-between gap-3 pb-3" data-id="element-226" data-mp="1kl8aqym9djbu">
              <span className="text-[15px] font-medium text-white/85" data-id="element-227" data-mp="1kj3wbmqqh1xb">
                6 Manuels Maîtres de référence
              </span>
              <span className="shrink-0 text-sm font-bold text-white/45 line-through" data-id="element-228" data-mp="1bk0cggjqsihr">
                492 €
              </span>
            </div>
            <div className="flex items-baseline justify-between gap-3 py-3" data-id="element-229" data-mp="16ns1zgghpdgx">
              <span className="text-[15px] font-medium text-white/85" data-id="element-230" data-mp="23bg7myzd7djl">
                5 Bonus exclusifs
              </span>
              <span className="shrink-0 text-sm font-bold text-white/45 line-through" data-id="element-231" data-mp="1zch2pedmvgs5">
                245 €
              </span>
            </div>
            <div className="flex items-baseline justify-between gap-3 pt-3" data-id="element-232" data-mp="1plcpok7iq5zy">
              <span className="text-xs font-extrabold uppercase tracking-[0.15em] text-white/60" data-id="element-233" data-mp="2mzp07a4tlljm">
                Valeur totale du système
              </span>
              <span className="shrink-0 font-display text-2xl font-bold text-white/50 line-through" data-id="element-234" data-mp="2i7xhtmvtim4k">
                737 €
              </span>
            </div>
          </div>

          <div className="border-t border-white/10 bg-ink-900 px-5 py-7 text-center sm:px-6" data-id="element-235" data-mp="3638yd59n7e0v">
            <p className="text-sm text-white/60" data-id="element-236" data-mp="2scdvqapqlt5q">
              Mais aujourd’hui, vous ne paierez pas 737 €…
            </p>
            <p className="mt-4 text-[11px] font-extrabold uppercase tracking-[0.2em] text-spark-500" data-id="element-237" data-mp="2wcxv7kxs98v1">
              Accédez aujourd’hui pour seulement
            </p>
            <p className="mt-1 font-display text-7xl font-bold leading-none text-spark-400 sm:text-8xl" data-id="element-238" data-mp="2nf3w628mw146">
              19 €
            </p>

            <ul className="mx-auto mt-5 grid max-w-xs grid-cols-2 gap-2 text-left" data-id="element-239" data-mp="29ge3qzwrepm5">
              {['Paiement unique', 'Sans abonnement', 'Accès immédiat', 'Accès à vie'].map(item => <li key={item} className="flex items-center gap-1.5 text-xs font-semibold text-white/75" data-id="element-240" data-mp="7l3pggy0n4je">
                    <span className="text-arc-400" aria-hidden="true" data-id="element-241" data-mp="1w73psdxuw9w3">
                      ✓
                    </span>
                    {item}
                  </li>)}
            </ul>

            <p className="mx-auto mt-5 flex max-w-sm items-start justify-center gap-2 rounded-lg bg-arc-500/10 px-3 py-2.5 text-left text-[11px] leading-snug text-arc-300" data-id="element-242" data-mp="25ygkreeybg6c">
              <GlobeIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-243" data-mp="2ft034joxulmr" />
              Le changement de devise est automatique : le paiement est converti dans votre
              devise locale lorsque cela est applicable.
            </p>

            <div className="mt-6" data-id="element-244" data-mp="2jwem9j86bi4f">
              <CtaBlock label="Je veux le Système Maître de Soudage" note="" data-id="element-245" data-mp="2jxg8mjun3r1g" />
            </div>
          </div>
        </div>

        <div className="mt-6 rounded-2xl border border-red-500/30 bg-red-500/[0.07] p-5" data-id="element-246" data-mp="uhgt8l0fh5dd">
          <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-red-300" data-id="element-247" data-mp="pjotx5xgegz5">
            <HourglassIcon className="h-4 w-4" aria-hidden="true" data-id="element-248" data-mp="ryvc1grvztk4" />
            Places presque épuisées
          </p>
          <p className="mt-3 font-display text-2xl font-bold uppercase text-white" data-id="element-249" data-mp="10xgxpksnnop4">
            Il ne reste que {SPOTS_LEFT} places
          </p>
          <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-ink-950" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Places réservées au tarif de lancement" data-id="element-250" data-mp="15v8rylgrvmwh">
            <div className="h-full rounded-full bg-red-500" style={{
            width: `${filled}%`
          }} data-id="element-251" data-mp="i67eukwzvnkv" />
          </div>
          <p className="mt-2.5 text-sm leading-snug text-white/70" data-id="element-252" data-mp="3lnpish9ncag0">
            <span className="font-bold text-white" data-id="element-253" data-mp="3lnfucy492bcf">{filled} %</span> des places déjà prises
            — plus que {SPOTS_LEFT} accès disponibles avant la fermeture du tarif
            promotionnel de lancement.
          </p>
        </div>

        <p className="mt-6 text-balance text-center text-sm italic text-white/55" data-id="element-254" data-mp="3e4gc4vsiypun">
          Moins qu’une petite dépense pour votre atelier… pour un outil de référence que
          vous pourrez consulter pendant des années.
        </p>

        <div className="mt-8" data-id="element-255" data-mp="3457iy55hhf9c">
          <CtaBlock label="Réserver ma place à 19 €" data-id="element-256" data-mp="3483hnvp5o7yu" />
        </div>
      </div>
    </section>;
}